import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f91dbd44"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "illustrate" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "illustrate-item" }, [
    /*#__PURE__*/_createElementVNode("span", null, " 本保险含驾驶员伤害补偿险，可承保保险期间操作员操作农业无人机时发生的对驾驶员的人身造成的伤害 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "illustrate-item" }, [
    /*#__PURE__*/_createElementVNode("span", null, "每架农业无人机可对应登记多个操作员信息。")
  ])
], -1))
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "content-item-left" }
const _hoisted_4 = { class: "content-item-right" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "button" }
const _hoisted_7 = { class: "ActionSheet" }

import AppHeader from '@/components/Header.vue'
import { Divider, Button, ActionSheet, Dialog, Toast, ActionSheetAction } from 'vant'
import { useRouter, useRoute } from 'vue-router'
import { AxiosError } from 'axios'
import { ref, onMounted, reactive, Ref, withDefaults } from 'vue'
import { getServiceList, modifyOperator } from '@/apis/three-liability-insurance'
import { useStore } from 'vuex'
import { OperatorItemType, serviceItem } from '@/types/three-liability-insurance'
type selectOption = {
  name: string
  color?: string
}

type operatorItem = {
  name: string
  id_card: string
  phone: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'operator',
  props: {
    displayMode: { default: 'Portrait' }
  },
  setup(__props: any) {

const props = __props as { displayMode: string };


let show = ref(false)
const router = useRouter()
const route = useRoute()
let operator: Ref<OperatorItemType[]> = ref([])
const store = useStore()
const updated_by = store.state.userInfo.realName
let sn = route.query.sn as string
const cacheKey = route.query.cacheKey as string
const actionSave: ActionSheetAction[] = [
  { name: '编辑', className: 'fix-font' },
  { name: '删除', color: '#F85359', className: 'border-top', disabled: false },
]
const actions: Ref<ActionSheetAction[]> = ref(actionSave.map((item) => ({ ...item })))
let currentOperateText = ref('')
const onSelect = (item: selectOption, index: number) => {
  console.log('selectItem', item, index)
  const currentIndex = operator.value.indexOf(currentOperator)
  console.log('currentIndex', currentIndex)
  if (index === 0) {
    router.push({
      name: 'add-operator',
      query: {
        sn,
        currentIndex,
        cacheKey,
      },
    })
  }
  if (index === 1) {
    Dialog.confirm({
      message: '确认删除此操作员信息？',
      confirmButtonText: '确认',
    })
      .then(() => {
        // on confirm
        currentOperateText.value = '删除'
        // delOperatorHandle()
        operator.value[currentIndex].status = 'D'
        submitOperator()
      })
      .catch(() => {
        // on cancel
      })
  }
}
let currentOperator: OperatorItemType
let policy_no = ref('')
const operatorClickHandle = (item: OperatorItemType, index: number) => {
  currentOperator = item
  show.value = true
  actions.value =
    operator.value.length === 1
      ? actionSave.filter((item) => item.name !== '删除').map((item) => ({ ...item }))
      : actionSave.map((item) => ({ ...item }))
}
const onCancel = () => {
  show.value = false
}
// 暂时不用添加
const addOperator = () => {
  router.push({
    name: 'add-operator',
    query: {
      sn,
    },
  })
}

function delOperatorHandle() {
  let findIndex = operator.value.indexOf(currentOperator)
  if (findIndex !== -1) {
    operator.value.splice(findIndex, 1)
  }
}

async function submitOperator() {
  try {
    Toast.loading({
      message: `${currentOperateText.value}中...`,
      duration: 0,
    })
    await modifyOperator({
      policy_no: policy_no.value,
      updated_by,
      operator_list: operator.value,
    })
    getListData(sn)
    Toast.clear()
    Toast.success(`${currentOperateText.value}成功`)
  } catch (e) {
    console.log('e', e)
    Toast.clear()
    Toast.fail((e as AxiosError)?.message || '网络连接错误，请稍后再试')
  }
}

async function getListData(sn: string) {
  let data
  try {
    Toast.loading({
      message: '加载中...',
      duration: 0,
    })
    const cacheDataStr = sessionStorage.getItem(cacheKey)
    data =
      cacheDataStr && cacheDataStr !== 'null'
        ? (JSON.parse(cacheDataStr) as serviceItem)
        : await getServiceList({ sn })
    operator.value = JSON.parse(data.operator).map((item: OperatorItemType) => ({
      ...item,
      status: 'U',
      old_id_card: item.id_card,
    }))
    policy_no.value = data.policy_no
    Toast.clear()
  } catch (e) {
    Toast.clear()
    if ((e as { status: number }).status === 4304) {
      console.log('dd')
      Toast.fail('登录失效,请重新登录后再试')
    } else {
      Toast.fail((e as AxiosError)?.message || '网络连接错误，请稍后再试')
    }
  }
  return data
}

onMounted(async () => {
  void (await getListData(sn))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "操作员" }),
    _createElementVNode("div", {
      class: _normalizeClass(["page-content", props.displayMode === 'Landscape' ? 'landscape-width' : ''])
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operator), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["content-item", index > 0 ? 'van-hairline--top' : '']),
            key: index
          }, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(index + 1), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(item.name) + "(" + _toDisplayString(item.id_card) + ")", 1),
              _createElementVNode("span", null, _toDisplayString(item.phone), 1)
            ]),
            _createElementVNode("div", {
              class: "operator-icon",
              onClick: ($event: any) => (operatorClickHandle(item, index))
            }, null, 8, _hoisted_5)
          ], 2))
        }), 128)),
        _createVNode(_unref(Divider), { style: { padding: '0 0', margin: '0 0' } })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(Button), {
          color: "#02c37b",
          style: { width: '100%' },
          onClick: addOperator
        }, {
          default: _withCtx(() => [
            _createTextVNode("添加操作员信息")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(ActionSheet), {
          show: _unref(show),
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_isRef(show) ? (show).value = $event : show = $event)),
          actions: actions.value,
          onSelect: onSelect,
          "cancel-text": "取消",
          "close-on-click-action": "",
          onCancel: onCancel
        }, null, 8, ["show", "actions"])
      ])
    ], 2)
  ], 64))
}
}

})